var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodFit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3714 8.73273C14.6 8.53895 14.4767 8.16552 14.1777 8.14587L12.6666 8.04652C12.5383 8.03808 12.4263 7.95662 12.3787 7.83718L11.8085 6.40451C11.697 6.12443 11.3006 6.12443 11.1891 6.40451L10.6188 7.83719C10.5712 7.95663 10.4593 8.03809 10.331 8.04653L8.82167 8.14587C8.52281 8.16554 8.39951 8.53872 8.62781 8.73257L9.79037 9.71971C9.88745 9.80214 9.92907 9.93268 9.89763 10.0561L9.51635 11.5527C9.44193 11.8448 9.76266 12.0778 10.0175 11.9168L11.3207 11.093C11.4294 11.0243 11.5681 11.0243 11.6769 11.093L12.9801 11.9168C13.2349 12.0778 13.5556 11.8448 13.4812 11.5527L13.1 10.0562C13.0685 9.93276 13.1102 9.80213 13.2074 9.71971L14.3714 8.73273Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67969 4.66979C2.67969 2.92779 4.09186 1.51562 5.83385 1.51562C7.57585 1.51562 8.98802 2.92779 8.98802 4.66979C8.98802 6.41179 7.57585 7.82396 5.83385 7.82396C4.09186 7.82396 2.67969 6.41179 2.67969 4.66979Z",
    fill: "#252919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.679688 14.0031C0.679688 11.1566 2.98729 8.84896 5.83385 8.84896C6.10671 8.84896 6.37461 8.87016 6.636 8.91101C6.69232 9.02584 6.77098 9.13026 6.86998 9.21689L8.5332 10.3364L8.19987 12.3364C8.10336 12.7269 8.19987 13.1028 8.56385 13.3753C8.9571 13.6698 9.53609 13.5517 9.86654 13.3364L10.8566 12.8414C10.9426 13.2148 10.988 13.6036 10.988 14.0031C10.988 14.2724 10.7698 14.4906 10.5005 14.4906H1.16719C0.897949 14.4906 0.679688 14.2724 0.679688 14.0031Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodFit);
export default __webpack_public_path__ + "static/media/good-fit.5826473fed1d2f9c8fc693b1bb849233.svg";
export { ForwardRef as ReactComponent };